import Confirmation from "../Modal/Confirmation";
import { useResetCart } from "@/shared/hooks/useCartHook";
import { useSetModal } from "@/shared/atoms/useModal";

const PosOrderResetCartModal = () => {
  const resetCart = useResetCart();
  const setModal = useSetModal();

  return (
    <Confirmation
      onSuccess={() => {
        resetCart();
        setModal("");
      }}
      show={true}
      onExit={() => setModal("")}
    />
  );
};

export default PosOrderResetCartModal;
